import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import EeeData from "./DepData/eeeData";
import "./style.css"; 
import Navigation from "./navigation";
import Lab1 from "../images/eeelab1.jpg";
import Lab2 from '../images/eeelab2.jpg';
import Lab3 from '../images/eeelab3.jpg';
import Lab4 from '../images/eeelab4.jpg';
import Lab5 from '../images/eeelab5.jpg';
import cse from "../home/departments/Computer Departmet.jpg";
import ece from "../home/departments/ECE Department.jpg";
import eee from "../home/departments/EEE Department.jpg";
import mech from "../home/departments/Mech Department.jpg";
import general from "../home/departments/General Department1.jpg";


const Cse = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch data from the backend
    fetch("https://gptkpm.in/backend/admin/eee-dept-img.php")
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setData(data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);


  const navigate = useNavigate();
    const handleNavigation = (path) => {
      navigate(path);
    };
  return (
    <div className="cse-container">
      <Header />
      <Navigation />
      <EeeData />

      <div className="notebook-container">
        <div className="notebook">
          <div className="page vision-page">
            <h2 className="page-title">Vision of the department: </h2>
            <p style={{ lineHeight: "30px" }}>
            The Vision of the Department is to be a premier and value based department committed to excellence in preparing students for success in Electrical Engineering and Technology Professions to face the challenges.</p>
                      </div>
          <div className="page mission-page">
            <h2 className="page-title">Mission of the department:</h2>
            <ul style={{ listStyle: "none", lineHeight: "40px" }}>
              <li>M1:-To enable students to develop skills to solve complex technological problems of current times and also provide a framework for promoting collaborative and multidisciplinary activities
              </li>
              <li>M2:-To inculcate moral and ethical values among the faculty and students
              </li>
              <li>M3:-To provide quality teaching blended with Practical engineering skills.
              </li>
              <li>M4:-To prepare students to develop all rounded competitiveness.
              </li>
            </ul>
          </div>
          <div className="page program-objectives-page">
            <h2 className="page-title">Program Educational Objectives</h2>
            <ul>
              <li>PEO1 An ability to apply  knowledge of  mathematics, Science , engineering  and management principles in solving problems in the field of Electrical and Electronics Engineering.</li>
              <li>PEO2 To be life-long learners with sprit of enquiry and zeal to acquire new knowledge and skills so as to remain contemporary and posses required professional skills.</li>
              <li>PEO3 To enhance entrepreneurial, communication and other soft skills, which will enable them to work globally as leaders, team members and contribute to nation building for the betterment of the society. </li>
              <li>PEO4 To make them strongly committed to the highest levels of professional ethics and focus on ensuring quality, adherence to public policy and  law, safety, reliability and environmental sustainability in all their professional activities </li>
            </ul>
          </div>
          <div className="page program-objectives-page">
      <h2 className="page-title">Program Outcomes</h2>
      <ul>
        <li>P01: Basic and discipline-specific knowledge:
        Apply knowledge of basic mathematics, science, engineering fundamentals, and an engineering specialization to solve engineering problems.</li>
        <li>P02: Problem Analysis:
        Identify and analyze well-defined engineering problems using codified standard methods.</li>
        <li>P03: Design/development of solutions:
        Design solutions for well-defined technical problems and assist with the design of systems components or processes to meet specified needs.</li>
        <li>PO4: Engineering tools, experimentation, and testing:
        Apply modern engineering tools and appropriate techniques to conduct standard tests and measurements.</li>
        <li>PO5: Engineering practices for society, sustainability, and environment:
        Apply appropriate technology in the context of society, sustainability, environment, and ethical practices.</li>
        <li>P06: Project management:
        Use engineering management principles individually, as a team member, or as a leader to manage projects and effectively communicate about well-defined engineering activities.</li>
        <li>P07:Life-long learning:
        Ability to analyze individual needs and engage in updating in the context of technological changes.</li>
      </ul>
    </div>
          <div className="page program-outcomes-page">
            <h2 className="page-title">Program Specific Outcomes</h2>
            <ul>
              <li>PSO1: An ability to understand the  basic concepts of Electrical & Electronics Engineering and to apply them to various areas like  Wiring Installations, Lighting Schemes , Static & Rotating machinery, drawing  layouts , Power System ( Generation, Transmission, Distribution& utilisation), Digital electronics, power control devices, Computer programming ,managerial  skills  and the use SMART technologies .</li>
              <li>PSO2: An ability to Repair, develop and trouble shooting of Various Electrical & Electronics equipment’s by using suitable tools and techniques, to design Customized applications in Electrical & Electronics Engineering at economic and efficient considerations, to develop software & hardware solutions.</li>
              <li>PSO3: Wisdom of social and environmental awareness along with ethical responsibility to have a successful career and to sustain passion and zeal in  the field of Electrical & Electronics Engineering for real-world applications in the field of Electronics using optimal resources as an Entrepreneur.</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="sec-2">
        <h3 className="section-title">Staff Members/ Faculty</h3>
        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : (
          <div className="staff-grid">
            {data.map((item) => (
              <div key={item.id} className="staff-card">
                <img
                  src={item.image}
                  alt="EEE"
                  className="staff-image"
                />
                <div className="staff-detail">
                  <h2 className="staff-name">Name: {item.name}</h2>
                  <p className="staff-profession">
                    Profession: {item.profession}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="sec-3">
  <h2>Labs</h2>
  <div id="lab">
    <div className="lab-item">
      <img src={Lab1} alt="Lab 1" />
      <p className="lab-name">MACHINES LAB I</p>
    </div>
    <div className="lab-item">
      <img src={Lab2} alt="Lab 2" />
      <p className="lab-name">POWER ELECTRONICS</p>
    </div>
    <div className="lab-item">
      <img src={Lab3} alt="Lab 3" />
      <p className="lab-name">MACHINES LAB II</p>
    </div>
    <div className="lab-item">
      <img src={Lab4} alt="Lab 4" />
      <p className="lab-name">CONTROL SYSTEMS</p>
    </div>
    <div className="lab-item">
      <img src={Lab5} alt="Lab 5" />
      <p className="lab-name">POWER ELECTRONICS</p>
    </div>
  </div>
</div>

<div id="part-5">
              <div id="part-5-left">
                <h2>Departments</h2>
                <p>Here is a list of all the departments in the college</p>
              </div>
              <div id="part-5-right" className="horizontal-scroll-container">
                <div className="img-dept">
                  <img src={cse} alt="DCME Department" />
                  <button onClick={() => handleNavigation("/cse")}>DCME</button>
                </div>
                <div className="img-dept">
                  <img src={ece} alt="DECE Department" />
                  <button onClick={() => handleNavigation("/Ece")}>DECE</button>
                </div>
                <div className="img-dept">
                  <img src={eee} alt="DEEE Department" />
                  <button onClick={() => handleNavigation("/Eee")}>DEEE</button>
                </div>
                <div className="img-dept">
                  <img src={mech} alt="DME Department" />
                  <button onClick={() => handleNavigation("/Mech")}>DME</button>
                </div>
                <div className="img-dept">
                  <img src={general} alt="General Department" />
                  <button onClick={() => handleNavigation("/General")}>General</button>
                </div>
              </div>
            </div>      

      <Footer />
    </div>
  );
};

export default Cse;
